import React, { Fragment, useEffect, useState } from 'react';
import BrexitComplaintsDataComponent from '../components/BrexitComplaintsDataComponent';
import BrexitComplaintsDataSheet from '../components/BrexitComplaintsDataSheet';
import { trackLink, trackPage } from '../../lib/analytics-helper';

const complaintDataSheetTitle = 'Complaint Data Sheet';

function BrexitComplaintsDataContainer() {
  const [isComplaintDataSheetOpen, setIsComplaintDataSheetOpen] = useState(false);
  const openComplaintDataSheet = () => {
    trackLink({ id: 'complaintsDataSheetOpen', link: 'smarthelp-complaints-data-sheet-clicked|open' });
    setIsComplaintDataSheetOpen(true);
  };
  const closeComplaintDataSheet = () => {
    trackLink({ id: 'complaintsDataSheetClose', link: 'smarthelp-complaints-data-sheet-clicked|close' });
    setIsComplaintDataSheetOpen(false);
  };

  useEffect(() => {
    trackPage({ id: 'complaintsDataPanel', link: 'smarthelp-complaints-data' });
  }, []);

  const renderComplaintsDataSection = () => {
    return <BrexitComplaintsDataComponent openSheetEvent={openComplaintDataSheet} />;
  };

  const renderComplaintsDataSheet = () => {
    return (
      <BrexitComplaintsDataSheet
        complaintDataSheetTitle={complaintDataSheetTitle}
        isComplaintDataSheetOpen={isComplaintDataSheetOpen}
        handleSheetClose={closeComplaintDataSheet}
      />
    );
  };

  return (
    <Fragment>
      {renderComplaintsDataSection()}
      {renderComplaintsDataSheet()}
    </Fragment>
  );
}

export default BrexitComplaintsDataContainer;
